import { account } from "./account";
import { beschikbaarheid } from "./beschikbaarheid";
import { common } from "./common";
import { deelname } from "./deelname";
import { inschrijfperiodes } from "./inschrijfperiodes";
import { koppelingen } from "./koppelingen";
import { lokaleAccounts } from "./lokaleAccounts";
import { navigatie } from "./navigatie";
import { paginas } from "./paginas";
import { planning } from "./planning";
import { ploegen } from "./ploegen";
import { reistijden } from "./reistijden";
import { session } from "./session";
import { stamgegevens } from "./stamgegevens";
import { standaardteksten } from "./standaardteksten";
import { synchronisaties } from "./synchronisaties";
import { wedstrijdboekjes } from "./wedstrijdboekjes";
import { wedstrijden } from "./wedstrijden";

/**
 * Everything this backoffice says, in Dutch. One namespace per feature folder, plus `common` for
 * what more than one of them needs, `navigatie` for the sidebar's tree and `paginas` for the
 * sentence under each page title - the same seam the code is already cut along.
 *
 * What is deliberately not here: the sentences the API writes. A planning's waarschuwingen and
 * the overzicht's aandachtspunten are the server's prose, keyed on a stable code so it may
 * reword them, and copying them here would give the same sentence two owners.
 */
export const nl = {
  account,
  beschikbaarheid,
  common,
  deelname,
  inschrijfperiodes,
  koppelingen,
  lokaleAccounts,
  navigatie,
  paginas,
  planning,
  ploegen,
  reistijden,
  session,
  stamgegevens,
  standaardteksten,
  synchronisaties,
  wedstrijdboekjes,
  wedstrijden,
} as const;
